import { Tag as TagV3_0 } from '@criteria/openapi/v3.0'
import { Tag as TagV3_1 } from '@criteria/openapi/v3.1'
import { invariant } from '../../lib/invariant'
import { Change, OpenAPI } from './Change'

export type Tag = TagV3_0 | TagV3_1

export class InsertTag extends Change {
  constructor(readonly index: number, readonly value: Tag) {
    super()
  }

  apply(document: OpenAPI) {
    invariant(
      document.tags?.every((tag) => tag.name !== this.value.name) ?? true,
      `Tag named '${this.value.name}' already exists`
    )
    document.tags ??= []
    document.tags.splice(this.index, 0, this.value)
  }
}

export class UpdateTagName extends Change {
  constructor(readonly index: number, readonly value: string) {
    super()
  }

  apply(document: OpenAPI) {
    invariant(document.tags && this.index < document.tags.length)
    invariant(
      document.tags?.filter((tag, i) => i !== this.index).every((tag) => tag.name !== this.value) ?? true,
      `Tag named '${this.value}' already exists`
    )
    document.tags[this.index].name = this.value
  }
}

export class UpdateTagDescription extends Change {
  constructor(readonly index: number, readonly value: string) {
    super()
  }

  apply(document: OpenAPI) {
    invariant(document.tags && this.index < document.tags.length)
    document.tags[this.index].description = this.value
  }
}

export class RemoveTag extends Change {
  constructor(readonly index: number, readonly deleteArrayIfEmpty: boolean) {
    super()
  }

  apply(document: OpenAPI) {
    let tags = document.tags ?? []
    tags.splice(this.index, 1)
    if (tags.length === 0 && this.deleteArrayIfEmpty) {
      delete document.tags
    }
  }
}
